import { render, staticRenderFns } from "./Collectors.vue?vue&type=template&id=169d5ef8&scoped=true&"
import script from "./Collectors.vue?vue&type=script&lang=js&"
export * from "./Collectors.vue?vue&type=script&lang=js&"
import style0 from "./Collectors.vue?vue&type=style&index=0&id=169d5ef8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169d5ef8",
  null
  
)

export default component.exports